import { weakHash, coerceQuery, } from '@instantdb/core';
import { useCallback, useRef, useSyncExternalStore } from 'react';
const defaultState = {
    isLoading: true,
    data: undefined,
    pageInfo: undefined,
    error: undefined,
};
function stateForResult(result) {
    return Object.assign({ isLoading: !Boolean(result), data: undefined, pageInfo: undefined, error: undefined }, (result ? result : {}));
}
export function useQueryInternal(_core, _query, _opts) {
    if (_query && _opts && 'ruleParams' in _opts) {
        _query = Object.assign({ $$ruleParams: _opts['ruleParams'] }, _query);
    }
    const query = _query ? coerceQuery(_query) : null;
    const queryHash = weakHash(query);
    // We use a ref to store the result of the query.
    // This is becuase `useSyncExternalStore` uses `Object.is`
    // to compare the previous and next state.
    // If we don't use a ref, the state will always be considered different, so
    // the component will always re-render.
    const resultCacheRef = useRef(stateForResult(_core._reactor.getPreviousResult(query)));
    // Similar to `resultCacheRef`, `useSyncExternalStore` will unsubscribe
    // if `subscribe` changes, so we use `useCallback` to memoize the function.
    const subscribe = useCallback((cb) => {
        // Update the ref when the query changes to avoid showing stale data
        resultCacheRef.current = stateForResult(_core._reactor.getPreviousResult(query));
        // Don't subscribe if query is null
        if (!query) {
            const unsubscribe = () => { };
            return unsubscribe;
        }
        const unsubscribe = _core.subscribeQuery(query, (result) => {
            resultCacheRef.current = Object.assign({ isLoading: !Boolean(result), data: undefined, pageInfo: undefined, error: undefined }, result);
            cb();
        });
        return unsubscribe;
    }, 
    // Build a new subscribe function if the query changes
    [queryHash]);
    const state = useSyncExternalStore(subscribe, () => resultCacheRef.current, () => defaultState);
    return { state, query };
}
//# sourceMappingURL=useQuery.js.map